import Main from '@/views/Main.vue';

const CandidateForm = () => import('@/views/main/CandidateForm.vue');

const Auth = () => import('@/views/Auth.vue');
const AuthCallback = () => import('@/views/AuthCallback.vue');

const NotFound = () => import('@/views/error/NotFound.vue');
const AccessDenied = () => import('@/views/error/AccessDenied.vue');

export default [
  {
    path: '/',
    name: 'main',
    component: Main,
    redirect: { name: '' },
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'CandidateForm',
        component: CandidateForm,
      },
      {
        path: '404',
        name: 'notFound',
        component: NotFound,
      },
      {
        path: '403',
        name: 'accessDenied',
        component: AccessDenied,
      },
    ],
  },
  {
    path: '/auth',
    name: 'auth',
    component: Auth,
    meta: { requiresAnon: true },
  },
  {
    path: '/auth/callback',
    name: 'authCallback',
    component: AuthCallback,
    meta: { requiresAnon: true },
  },
  {
    path: '*',
    redirect: { name: 'notFound' },
  },
];
